/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Words_LabelInputs */

const en_dialog_text_to_audio_words_label = /** @type {(inputs: Dialog_Text_To_Audio_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`words`)
};

const es_dialog_text_to_audio_words_label = /** @type {(inputs: Dialog_Text_To_Audio_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palabras`)
};

/**
* | output |
* | --- |
* | "words" |
*
* @param {Dialog_Text_To_Audio_Words_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_words_label = /** @type {((inputs?: Dialog_Text_To_Audio_Words_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Words_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_words_label(inputs)
	return en_dialog_text_to_audio_words_label(inputs)
});